import { connect } from 'react-redux';

import { isAppMode as isAppModeFunc } from 'settings/selectors';

// constants
import { applicationTypes } from 'constants/scripts';
import { inputStates } from 'constants/values';

// requesters
import { requestManualPlantingPlanFormData } from 'manual/requesters';

// actions
import {
  populateFertilizerProductInput,
  setActiveSubstanceTypeUuid,
  setHasNitrapyrin
} from 'current/uiwidgets';
import { updatePlantingPlanParams } from 'planting-plan-form';

// selectors
import {
  getAllActivitiesByActivityType,
  getFertilityActivityCategoriesOrdered
} from 'activities/selectors';
import {
  getActiveScriptType,
  showScriptNameInput
} from 'current/selectors';
import {
  isPlantingPlanLocked
} from 'current/uiwidgets/selectors';
import {
  getSubstanceTypesForApplicationType
} from 'products/fertility-selectors';
import {
  getPlantingPlanMaxDate,
  getPlantingPlanMinDate,
  getPlantingPlanParams,
  hasPlantingPlanSubstanceType,
  plantingPlanSubstanceTypeIsNitrogen
} from 'planting-plan-form/selectors';
import { getPlantingPlanParamsValidationResult } from 'validations/selectors';

import { setNitrapyrin, setScriptState } from 'scripts';
import { getNitrapyrin } from 'products/selectors';

import ManualPlantingPlanForm from './ManualPlantingPlanForm';
import moment from 'moment';

export default connect(
  (state) => {
    return {
      fertilityActivities: getAllActivitiesByActivityType(state),
      fertilityActivityCategories: getFertilityActivityCategoriesOrdered(state),
      hasSubstanceType: hasPlantingPlanSubstanceType(state),
      isAppMode: isAppModeFunc(state),
      maxDate: getPlantingPlanMaxDate(state),
      minDate: getPlantingPlanMinDate(state),
      nitrapyrin: getNitrapyrin(state),
      plantingPlanParams: getPlantingPlanParams(state),
      scriptType: getActiveScriptType(state),
      showScriptNameInput: showScriptNameInput(state),
      substanceTypeIsNitrogen: plantingPlanSubstanceTypeIsNitrogen(state),
      substanceTypes: getSubstanceTypesForApplicationType(state, applicationTypes.FERTILIZER),
      validationResult: getPlantingPlanParamsValidationResult(state),
      isPlantingPlanLocked: isPlantingPlanLocked(state)
    };
  },
  (dispatch) => {
    return {
      onChangePlantingFertilizerApplication: (e) => {
        dispatch(updatePlantingPlanParams({ hasPlantingFertilizerApplication: e.target.checked }));
      },
      onChangeScriptName: (e) => dispatch(updatePlantingPlanParams({ scriptName: e.target.value })),
      onMount: () => {
        dispatch(requestManualPlantingPlanFormData());
      },
      onSelectDate: (date) => {
        dispatch(updatePlantingPlanParams(
          { date: moment(date).format('YYYY-MM-DD') + moment(date).format('THH:mm:ss.SSS') + 'Z' })
        );
      },
      onSelectIncorporationMethod: (value) => {
        const incorporationMethod = value;
        dispatch(updatePlantingPlanParams({ incorporationMethod }));
      },
      onSelectSubstanceType: (value) => {
        const substanceTypeUuid = value;
        dispatch(updatePlantingPlanParams({ substanceTypeUuid }));
        dispatch(setActiveSubstanceTypeUuid({ substanceTypeUuid }));
        dispatch(populateFertilizerProductInput({ substanceTypeUuid }));
      },
      onChangeNitrapyrin: (e, scriptId, nitrapyrin) => {
        const hasNitrapyrin = e.target.checked;
        dispatch(updatePlantingPlanParams({ hasNitrapyrin }));
        dispatch(setHasNitrapyrin({ hasNitrapyrin }));
        dispatch(setNitrapyrin({ scriptId, hasNitrapyrin, nitrapyrin }));
        dispatch(setScriptState({ scriptId, scriptState: inputStates.CHANGED }));
      },
      onSelectFertilityActivityCategory: (activityCategoryUuid) => {
        dispatch(updatePlantingPlanParams({
          activityCategoryUuid,
          incorporationMethod: null,
          substanceType: null,
          hasNitrapyrin: null
        }));
        dispatch(populateFertilizerProductInput({ substanceType: null }));
        dispatch(setHasNitrapyrin({ hasNitrapyrin: null }));
      }
    };
  }
)(ManualPlantingPlanForm);
